import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import switchImage from '../../assets/img/icon-migration.svg';
import domainImage from '../../assets/img/switch-domain.svg';
import switchIcon1 from '../../assets/img/switch-1.svg';
import switchIcon2 from '../../assets/img/switch-2.svg';
import domainIcon1 from '../../assets/img/switch-domain-1.svg';
import domainIcon2 from '../../assets/img/switch-domain-2.svg';
import './switchWidget.scss';

function SwitchWidget({ dataType }) {
    const { t } = useTranslation();
    let switchData = [
        {
            title: t('web-hosting-page.switch-column.title-1'),
            text: t('web-hosting-page.switch-column.text-1'),
            image: switchIcon1
        },
        {
            title: t('web-hosting-page.switch-column.title-2'),
            text: t('web-hosting-page.switch-column.text-2'),
            image: switchIcon2
        }
    ];

    const domainData = [
        {
            title: t('domain-page.switch-column.title-1'),
            text: t('domain-page.switch-column.text-1'),
            image: domainIcon1
        },
        {
            title: t('domain-page.switch-column.title-2'),
            text: t('domain-page.switch-column.text-2'),
            image: domainIcon2
        }
    ];

    const isDomain = dataType === 'domain';

    if (isDomain) {
        switchData = domainData;
    }
    const renderSwitchItem = (item, index) => (
        <div className="single-switch" key={`${item.title}-${index}`}>
            <Row>
                <Col md={2}>
                    <img className="switch-image" src={item.image} alt="Easy migration" />
                </Col>
                <Col md={10}>
                    <div className="switch-info-wrapper">
                        <h3 className="switch-title">{item.title}</h3>
                        <p className="switch-text">{item.text}</p>
                    </div>
                </Col>
            </Row>
        </div>
    );

    return (
        <div className="switch-columns-wrapper">
            <Row>
                <Col md={6} xs={12}>
                    {switchData.map(renderSwitchItem)}
                </Col>
                <Col md={6} xs={12}>
                    <img
                        className="switch-main-image"
                        src={isDomain ? domainImage : switchImage}
                        alt="Switch"
                    />
                </Col>
            </Row>
        </div>
    );
}

SwitchWidget.propTypes = {
    dataType: PropTypes.string
};

SwitchWidget.defaultProps = {
    dataType: 'home'
};

export default SwitchWidget;
